var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      !_vm.isPreview
        ? _c("editor", {
            attrs: { id: _vm.id, init: _vm.editorOption },
            model: {
              value: _vm.content,
              callback: function ($$v) {
                _vm.content = $$v
              },
              expression: "content",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isPreview,
              expression: "isPreview",
            },
          ],
          staticClass: "preview",
        },
        [
          _vm.readonly === false
            ? _c("i", {
                staticClass: "el-icon-close",
                on: { click: _vm.close },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "ql-container ql-snow preview" }, [
            _c("div", { staticClass: "ql-editor" }, [
              _c("div", { domProps: { innerHTML: _vm._s(_vm.content) } }),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }